var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    staticClass: "page"
  }, [_c("div", {
    staticClass: "content_order"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("div", {
    staticClass: "title_block"
  }), _c("div", {
    staticClass: "title_content"
  }, [_c("span", [_vm._v("上午好，欢迎使用青少年体育信息管理系统")]), _c("span", [_vm._v("您上次登录的时间为：" + _vm._s(this.date))])])])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };